export default __webpack_public_path__ + "static/media/main2.2747e236.jpg";